<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR' | translate }}</label>
          <input type="text" pInputText id="idRangoInferior"
                 name="nomRangoInferior"
                 autocomplete="new-password"
                 moneda-reactive [minimo]="0"
                 formControlName="rangoInferior"
                 [maxlength]="18"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoInferior.invalid">
            {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR' | translate }}</label>
          <input type="text" pInputText id="idRangoSuperior"
                 name="nomRangoSuperior"
                 autocomplete="new-password"
                 moneda-reactive [minimo]="0"
                 formControlName="rangoSuperior"
                 [maxlength]="18"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoSuperior.invalid">
            {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO' | translate }}</label>
          <input type="text" pInputText id="idPorcentajeAplicado"
                 name="nomPorcentajeAplicado"
                 autocomplete="new-password" (blur)="calcularTarifa()"
                 numero-decimal-reactive [minimo]="0" [decimales]="2"
                 formControlName="porcentajeAplicado"
                 [maxlength]="5" [maximo]="100"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.porcentajeAplicado.invalid">
            {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA' | translate }}</label>
          <label class="falso-combo-texto">{{f.porcentajeTarifa.value}}</label>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{(regSeleccionado ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                type="button" (click)="onSubmit()"
                pButton></button>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="listado"
               [paginator]="true" [rows]="5"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.rangoInferior | dinero}}</td>
            <td>{{row.rangoSuperior | dinero}}</td>
            <td>{{row.porcentajeAplicado}}</td>
            <td>{{row.porcentajeTarifa}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="red-btn p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton style="background: red;"
                        (click)="inhabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="comision-freelance-tarifa">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
